export interface IfProps {
  children: React.ReactNode;
  condition: any;
}

/** @deprecated Please use inline boolean conditionals to render JSX */
export const If = ({ condition, children }: IfProps) => {
  const renderChildren =
    typeof children === "function" ? children : () => children;
  return condition ? renderChildren() : null;
};
